<div class="p-5 rounded apple-notification-form admin-form">
  <h2 class="m-8 font-bold">
    <fa-icon [icon]="platform === 'android' ? faAndroid : faApple"> </fa-icon> Files App
    {{ data.app.appId }}
  </h2>
  <div class="flex flex-col m-8 w-full">
    <label> Télécharger les fichiers pour la génération de l'archive </label>
    <rk-button
      [variant]="'secondary'"
      [icon]="'download'"
      [iconOnly]="true"
      (buttonClick)="onDownloadFiles()"
    ></rk-button>
  </div>
  <div class="flex flex-col m-8">
    <label>
      Importer l'archive
      <fa-icon [icon]="platform === 'android' ? faAndroid : faApple"> </fa-icon>
    </label>

    <input type="file" (change)="handleFileInput($event)" />
    <div class="m-5 w-full">
      @if (isUploading$ | async) {
        <mat-progress-spinner
          mode="indeterminate"
          [strokeWidth]="5"
          [diameter]="30"
        ></mat-progress-spinner>
      }
      @if (isUploaded) {
        <fa-icon class="text-valid text-3xl" [icon]="'check'"></fa-icon>
      }
    </div>
  </div>
</div>
